import { Button, Modal, Spin, Table } from "antd";
import React from "react";
import MergeModalCloseIcon from "../../icons/js/mergeModalCloseIcon";

const MergeLeadOpportunityModal = props => {
  const { visible, setVisible, handleMerge, loading, dataLoader, columns, tableData } = props;

  return (
    <Modal
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      width={1000}
      closable={false}
    >
      <div className="relative bg-white rounded-lg w-full h-auto">
        <div className="flex items-center justify-center relative">
          <div className="text-center font-bold text-2xl flex-1">Potential Duplicate Records</div>
          <MergeModalCloseIcon setVisible={setVisible} />
        </div>
        <div className="mt-4 text-center">
          <span>
            Choose data from the fields to continue the records into a single primary record.
          </span>
        </div>

        <div className="mt-12">
          {dataLoader ? (
            <div className="flex justify-center items-center h-[300px]">
              <Spin size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={false}
              scroll={{ x: "max-content", y: "300px" }}
              // style={{
              //   overflowX: "scroll",
              // }}
            />
          )}
        </div>
        <div className="flex flex-col h-full mt-6">
          <div className="flex items-center space-x-4 mb-4">
            <Button loading={loading} onClick={handleMerge} className="bg-[#3B82F6]">
              <span className="text-[#FFFFFF]">Merge</span>
            </Button>

            <Button onClick={() => setVisible(false)}>Cancel</Button>
            <span className="ml-4">
              <span className="text-[#EF4444]">Warning:</span>
              <br />
              <span className="text-[#334155]">
                Merging records is an irreversible action. Selected fields will be the final data
                for the merged record.
              </span>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MergeLeadOpportunityModal;
